__webpack_require__.p = "https://ikea.marat.qd.je/in/en/customer-service/support/";